/* istanbul ignore file */

// This function wraps access to `window.envConfig`, an object we use for runtime-based env config.
// For more info, see /server/middlewares/generateEnvConfig.js
export const getEnvConfig = key => {
  return window.envConfig[key];
};
